// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3-CBt","video":"_10l5x","cartouche":"_27x3k","description":"VAYTO","cta":"_3JnNY","transcriptionButton":"_3mJuk"};